export const COMPANY_NAME = "Barnala Labour Contracting";
export const PHONE_DISPLAY = "778-823-2000";
export const PHONE_TEL = "tel:+17788232000";
export const EMAIL = "barnalalabour@gmail.com";
export const MAILTO = `mailto:${EMAIL}`;
export const TAGLINE = "Every kind of labour. One trusted call.";

export const IMAGES = {
  greenhouse:
    "https://images.unsplash.com/photo-1761839257946-4616bcfafec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxncmVlbmhvdXNlJTIwYWdyaWN1bHR1cmUlMjBmYXJtaW5nJTIwaGFydmVzdCUyMHdvcmtlcnxlbnwwfHx8fDE3ODk0MTk2NDV8MA&ixlib=rb-4.1.0&q=85",
  farmField:
    "https://images.unsplash.com/photo-1626906722163-bd4c03cb3b9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxncmVlbmhvdXNlJTIwYWdyaWN1bHR1cmUlMjBmYXJtaW5nJTIwaGFydmVzdCUyMHdvcmtlcnxlbnwwfHx8fDE3ODk0MTk2NDV8MA&ixlib=rb-4.1.0&q=85",
  harvestCrew:
    "https://images.unsplash.com/photo-1605000797499-95a51c5269ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxncmVlbmhvdXNlJTIwYWdyaWN1bHR1cmUlMjBmYXJtaW5nJTIwaGFydmVzdCUyMHdvcmtlcnxlbnwwfHx8fDE3ODk0MTk2NDV8MA&ixlib=rb-4.1.0&q=85",
  cannerySorting:
    "https://images.unsplash.com/photo-1779517935508-990d5ef7e5be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxmb29kJTIwcGFja2FnaW5nJTIwY2FubmVyeSUyMGZhY3RvcnklMjB3b3JrZXJ8ZW58MHx8fHwxNzg5NDE5NjQ1fDA&ixlib=rb-4.1.0&q=85",
  canneryConveyor:
    "https://images.unsplash.com/photo-1762330018258-2cf9b8f80618?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxmb29kJTIwcGFja2FnaW5nJTIwY2FubmVyeSUyMGZhY3RvcnklMjB3b3JrZXJ8ZW58MHx8fHwxNzg5NDE5NjQ1fDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/about", label: "About", testId: "nav-link-about" },
  { to: "/services", label: "Services", testId: "nav-link-services" },
  { to: "/why-us", label: "Why Us", testId: "nav-link-why-us" },
  { to: "/testimonials", label: "Testimonials", testId: "nav-link-testimonials" },
  { to: "/contact", label: "Contact", testId: "nav-link-contact" },
];

export const SERVICES = [
  {
    id: "farm-labour",
    num: "01",
    title: "Farm Labour",
    image: IMAGES.farmField,
    blurb:
      "Season-ready field crews for berry farms, vegetable growers and orchards — from first planting to final harvest.",
    tasks: [
      "Planting & transplanting",
      "Harvesting & berry picking",
      "Pruning, weeding & hoeing",
      "Sorting, grading & packing",
      "General field maintenance",
    ],
  },
  {
    id: "greenhouse-labour",
    num: "02",
    title: "Greenhouse Labour",
    image: IMAGES.greenhouse,
    blurb:
      "Trained greenhouse hands for vegetable and flower operations — careful with the crop, quick on the line.",
    tasks: [
      "Crop work & plant maintenance",
      "Picking & harvesting",
      "Hydroponic system support",
      "Packaging & labelling",
      "Cleaning & sanitation",
    ],
  },
  {
    id: "cannery-labour",
    num: "03",
    title: "Cannery & Food Processing",
    image: IMAGES.canneryConveyor,
    blurb:
      "Dependable production-line workers for canneries and food processors when peak season hits hard.",
    tasks: [
      "Line assembly & sorting",
      "Quality control checks",
      "Palletizing & stacking",
      "Cold storage handling",
      "Wash-down & sanitation",
    ],
  },
];

export const REGIONS = [
  {
    id: "lower-mainland",
    name: "Lower Mainland",
    copy: "Rapid crew dispatch across the region, from Delta and Surrey to Mission.",
  },
  {
    id: "fraser-valley",
    name: "Fraser Valley",
    copy: "Deep roots in BC's farm country — Abbotsford, Chilliwack, Langley and beyond.",
  },
  {
    id: "greater-vancouver",
    name: "Greater Vancouver",
    copy: "Reliable labour for processors, greenhouses and distributors across the metro area.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Barnala's crew got our blueberry harvest in before the rain hit. On time every single morning — that's rare.",
    name: "Berry Farm Operator",
    place: "Abbotsford, Fraser Valley",
  },
  {
    quote:
      "Their greenhouse team treats the crop like it's their own. Careful picking, clean packing, zero drama.",
    name: "Greenhouse Grower",
    place: "Delta, Lower Mainland",
  },
  {
    quote:
      "During peak salmon season we needed twenty extra line workers on short notice. Barnala delivered.",
    name: "Cannery Production Manager",
    place: "Richmond, Greater Vancouver",
  },
  {
    quote:
      "Professional, punctual and easy to deal with. One phone call and the crew was sorted for the week.",
    name: "Vegetable Grower",
    place: "Chilliwack, Fraser Valley",
  },
];
